import { combineReducers } from '@reduxjs/toolkit';
import { mainReducer } from './slices/main-slice';

export const subscriptionReducers = combineReducers({
  main: mainReducer,
});
export type SubscriptionState = ReturnType<typeof subscriptionReducers>;
